<template>
  <div>
    <div class="gray-bg">
      <main-header ref="test"/>
    </div>
    <nav-bar class="d-md-block d-none"/>
    <div v-if="isLoaded">
      <div class="container">
        <div class="border-box">
          <div class="row no-gutters">
            <div class="col-sm-4 col-12">
              <v-img :alt="productInfo.Name" :src="$replaceHttps(productInfo.PictureUrl)" contain></v-img>
            </div>
            <div class="col-sm-4 col-12 pr-6 d-flex flex-column justify-center">
              <h1 class="font-weight-bold mt-4 font-16">{{ productInfo.Name }}</h1>
              <div class="mt-2">دسته بندی: <span>{{ productInfo.CategoryName }}</span></div>
              <div v-if="productInfo.CallForPrice" class="mt-3 ">
                <v-btn color="secondary" elevation="0" to="contactUs"><span class="font-12 ">برای اطلاع از قیمت تماس بگیرید</span>
                </v-btn>
              </div>
              <div v-else-if="productInfo.Discount === 0" class="mt-3  add-to-cart">
                {{ $numberWithCommas(productInfo.Price) }}
                تومان
              </div>
              <div v-else class="mt-3  add-to-cart">
                <span
                    class="text-decoration-line-through grey--text font-12">{{ $numberWithCommas(productInfo.Price) }}</span>
                {{ $computingPriceOffer(productInfo.Price, productInfo.Discount) }}
                تومان
              </div>
              <div v-if="productInfo.NotAvailable === true" class="mt-3  add-to-cart">
                اتمام موجودی
              </div>
              <div class="mt-3">توضیحات: <span>{{ productInfo.Description }}</span></div>
              <div class="mt-3 font-weight-bolder add-to-cart">حداقل سفارش: <span>{{ productInfo.MinimumOrder }}</span>
              </div>
              <div v-if="!productInfo.CallForPrice && !productInfo.NotAvailable && ! isExist " class="mt-6">
                <v-btn
                    large
                    outlined
                    rounded
                    @click="checkIfLoggedIn(productInfo.ProductID,productInfo.MinimumOrder)"
                >
                  <span class="add-to-cart"> <i class="fas fa-shopping-cart"></i> افزودن به سبد خرید </span>
                </v-btn>
              </div>
              <div v-else-if="isExist === true" class="mt-6">
                <div class="info-border">
                <span><i class="fas fa-plus mr-4 ml-5 font-14 pointer"
                         @click="plusProduct(productInfo.ProductID,productInfo.MinimumOrder)"></i></span>
                  <span class="font-16">{{ numberNeed }}</span>
                  <span v-if="productInfo.MinimumOrder < numberNeed"><i class="fas fa-minus mr-5 ml-4 font-14 pointer"
                                                                        @click="minusProduct(productInfo.ProductID,productInfo.MinimumOrder)"></i></span>
                  <span v-else class="mr-5 ml-4 second-color">
                            <span @click="deleteProduct(productInfo.ProductID)"> <i
                                class="fas fa-trash font-16 pointer"></i></span>
                  </span>
                </div>
              </div>
            </div>
            <div :class="productInfo.Discount === 0 ? 'visibility-hidden':true"
                 class="col-sm-3 col-12 text-sm-left text-center mt-5 position-absolute">
              <div class="discount-bg white--text px-3 py-1 mr-3 d-inline-block"><span>%</span>
                <span>{{ productInfo.Discount }} </span>
                <!--                <span>تخفیف</span>-->
              </div>
            </div>
            <div class="col-sm-4 col-12">
              <canvas id="priceChart" height="300" width="400"></canvas>

            </div>

          </div>
        </div>
        <div class="text-center border-bottom-title">
          <h2 class="mt-10">
            کالاهای مشابه
          </h2>
        </div>
        <div class="row">
          <div v-for="item in sameProducts" :key="item.ProductID" class="col-md-4 col-sm-4 col-6 ">
            <router-link :to="detailName+'?ProductID='+item.ProductID">
              <v-card class="mb-2 mt-5 pb-2">
                <div :class="item.Discount === 0 ? 'visibility-hidden':true" class="discount-bg d-inline-block">
                  <div class="white--text px-4 py-1 mt-1">
                    {{ item.Discount }}%
                  </div>
                </div>
                <div>
                  <v-img :alt="item.Name" :src="$replaceHttps(item.PictureUrl)" contain
                         height="120"></v-img>
                </div>
                <div class="text-center selected-goods-title">
                  {{ item.Name }}
                </div>
                <div class="text-center mt-1">
                  {{ item.NameCategory }}
                </div>
                <div v-if="item.CallForPrice" class="mt-3 text-center">
                  <v-btn color="secondary" elevation="0" to="contactUs"><span class="font-12 ">برای اطلاع از قیمت <br> تماس بگیرید</span>
                  </v-btn>
                </div>
                <!--                <div v-else class="mt-3 text-center add-to-cart">
                                  {{ $numberWithCommas(item.Price) }}
                                  تومان
                                </div>-->
                <div v-else-if="item.Discount === 0" class="mt-3 text-center add-to-cart">
                  {{ $numberWithCommas(item.Price) }}
                  تومان
                </div>
                <div v-else class="mt-3 text-center add-to-cart">
                  <span class="text-decoration-line-through grey--text font-12">
                    {{ $numberWithCommas(item.Price) }}</span>
                  {{ $computingPriceOffer(item.Price, item.Discount) }}
                  تومان
                </div>
                <div v-if="item.NotAvailable === true" class="mt-3 text-center add-to-cart">
                  اتمام موجودی
                </div>
              </v-card>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    <navigation-drawer :drawer="drawer"/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoginDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ loginResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 d-flex justify-content-center">
          <v-btn class="secondary" rounded @click="showLoginDialog = !showLoginDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 d-flex justify-content-between">
          <v-btn class="secondary" rounded @click="showResultDialog = !showResultDialog">
            ادامه خرید
          </v-btn>
          <v-btn class="secondary" rounded @click="goToCurrentBag">
            مشاهده سبد خرید
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showDeleteDialog"
        persistent
        width="500">
      <v-card class="text-center ">
        <v-card-title class="bg-darkGray">
          <v-btn color="secondary" icon small @click="showDeleteDialog = !showDeleteDialog">
            <i class="fas fa-times font-18 ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-3">
          <div class=" black--text font-16">آیا محصول از سبد خرید حذف شود؟</div>
        </v-card-text>
        <v-card-actions class="pt-1 pb-3 justify-content-center">
          <v-btn class="secondary" rounded @click="removeProduct()">
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {Chart} from "chart.js";

let _this = null
import NavBar from "./navBar";
import MainHeader from "./mainHeader";
import Footer from "./Footer";
import NavigationDrawer from "./navigationDrawer";

export default {
  name: "showProductInfo",
  metaInfo() {
    return {
      title: window.projectName + this.pageTitle,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.pageTitle,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.productImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.pageTitle,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.productImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.productImage
        }
      ]
    }
  },
  components: {NavigationDrawer, Footer, MainHeader, NavBar},
  data: () => ({
    isDelete: false,
    numberNeed: null,
    showDeleteDialog: false,
    isExist: false,
    drawer: false,
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: null,
    productInfo: {},
    sameProducts: [],
    isLoaded: false,
    detailName: null,
    orderValue: null,
    countOrder: 0,
    showLoginDialog: false,
    loginResult: null,
    productId: null,
    productMinOrder: null,
    minOrder: null,

    chartLabel: [],
    chartData: [],
    pageTitle: "",
    productImage:""
  }),
  mounted() {
    _this = this
    if (this.$router.currentRoute.path === "/productDetail1") {
      this.detailName = 'productDetail2'
    } else {
      this.detailName = 'productDetail1'
    }
    this.showLoaderDialog = true;
    this.getData();
    this.$watch(
        "$refs.test.currentBag",
        (new_value) => {
          if (new_value.length > 0) {
            this.getMainCurrentBagData()
          }
        }
    );
  },
  methods: {
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let id = this.$route.query.ProductID;

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/SearchEngine/ShowProductInfo", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.isLoaded = true

            _this.productInfo = json.list;
            this.orderValue = json.list.MinimumOrder;
            this.pageTitle = _this.productInfo.Name;
            this.productImage = _this.productInfo.PictureUrl;
            _this.showLoaderDialog = false;
            _this.sameProducts = json.SameProductinCategory;

            if (!json.list.DoNotShowPriceHistory) {
              setTimeout(() => {
                if (json.productPriceHistory.length > 0) {
                  let data = [];
                  let labels = [];

                  for (let i = 0; i < json.productPriceHistory.length; i++) {
                    labels.push(this.$convertDate(json.productPriceHistory[i].ModifiedDate));
                    //labels.push(json.productPriceHistory[i].ModifiedDate);
                    data.push(json.productPriceHistory[i].NewPrice);
                  }

                  const chartData = {
                    type: 'line',
                    data: {
                      labels: labels,
                      datasets: [{
                        label: "نمودار قیمت",

                        borderColor: '#252653',
                        showLine: true,
                        fill: false,
                        data: data,
                      }]
                    },
                    options: {
                      responsive: true,
                      rtl: true,
                      scales: {
                        xAxes: [{
                          display: true,
                        }],
                        yAxes: [{
                          display: true,
                        }]
                      }
                    }
                  };

                  Chart.defaults.global.defaultFontFamily = "IRANSans2";
                  const ctx = document.getElementById('priceChart');

                  new Chart(ctx, chartData);
                }
              }, 200);
            }

          })
          .catch(error => {
            _this.showLoaderDialog = false;
            _this.dialogResult = 'محصولی یافت نشد.';
            _this.showResultDialog = true
            console.log('error', error)
          });
    },
    deleteProduct(id) {
      this.showDeleteDialog = true
      this.id = id
    },
    plusProduct(id, minOrder) {
      this.isDelete = false
      _this.showLoaderDialog = true;

      let numberOrder = this.numberNeed + minOrder


      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", id);
      urlencoded.append("ValueAmount", numberOrder);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/AddOrder", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.dialogResult = result
            this.numberNeed = numberOrder
            _this.getData()
          })
          .catch(error => console.log('error', error));
    },
    minusProduct(id, minOrder) {
      this.showLoaderDialog = true
      let numberOrder = this.numberNeed - minOrder

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", id);
      urlencoded.append("ValueAmount", numberOrder);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/MinusOrder", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            if (this.numberNeed <= minOrder) {
              this.numberNeed = minOrder
              this.isDelete = true
            } else {
              this.isDelete = false
              this.numberNeed = numberOrder
            }


          })
          .catch(error => console.log('error', error));
    },
    removeProduct() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", this.id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/RemoveOrder", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showDeleteDialog = false;
            _this.showLoaderDialog = false;
            _this.dialogResult = result;
            this.isExist = false;
            window.$currentBagNav.getCurrentBagData()
            _this.getData();
          })
          .catch(error => console.log('error', error));
    },
    goToCurrentBag() {
      this.$router.push("currentBag")
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },

    getMainCurrentBagData() {
      let currentBag = this.$refs.test.currentBag
      if ((currentBag.filter(x => x.ProductID === this.$route.query.ProductID)).length > 0) {
        this.isExist = true
        this.numberNeed = currentBag.filter(x => x.ProductID === this.$route.query.ProductID)[0].NumberNeed
      } else {
        this.isExist = false
      }
    },
    checkIfLoggedIn(id, MinimumOrder) {
      if (this.$getUserData().token === '') {
        this.loginResult = "برای خرید ابتدا باید وارد سایت شوید"
        this.showLoginDialog = true
      } else {
        this.isExist = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("ProductID", id);
        urlencoded.append("ValueAmount", MinimumOrder);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Shopping/AddOrder", requestOptions)
            .then(response => response.text())
            .then(result => {
              this.numberNeed = MinimumOrder
              console.log(result)
              window.$currentBagNav.getCurrentBagData()
            })
            .catch(error => console.log('error', error));
      }
      this.productId = id
      this.productMinOrder = MinimumOrder
    },
    checkIfLoggedInMinus(id, MinimumOrder) {

      if (this.$getUserData().token === '') {
        this.dialogResult = "برای خرید ابتدا باید وارد سایت شوید"
        this.showResultDialog = true
      } else {
        this.minusProduct(id, MinimumOrder)
      }
    },
    /*showCurrentBagDialog(id, minOrder) {

      let numberOrder = minOrder + this.orderValue
      if (this.countOrder === 0) {
        this.orderValue = minOrder
      } else {
        this.orderValue = numberOrder
      }

      _this.showLoaderDialog = true;

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      console.log(this.$getUserData().token)

      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", id);
      urlencoded.append("ValueAmount", numberOrder);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/AddOrder", requestOptions)
          .then(response => response.text())
          .then(() => {
            _this.showLoaderDialog = false;
            this.countOrder++
            window.$currentBagNav.getCurrentBagData()
            console.log(this.countOrder++)
          })
          .catch(error => console.log('error', error));
    },*/
    showCurrentBagDialog(id, minOrder) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", id);
      urlencoded.append("ValueAmount", minOrder);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/AddOrder", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.showResultDialog = true
            this.dialogResult = "محصول به سبد خرید اضافه شد."
            window.$currentBagNav.getCurrentBagData()
            console.log(result)

          })
          .catch(error => console.log('error', error));
    },
    minusOrder(id, type) {
      this.showLoaderDialog = true
      let numberOrder = this.orderValue
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", id);
      urlencoded.append("ValueAmount", numberOrder);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/MinusOrder", requestOptions)
          .then(response => response.text())
          .then(() => {

            _this.showLoaderDialog = false;
            if (type === 1) {
              _this.showResultDialog = true;
              _this.dialogResult = 'محصول مورد نظر از سبد خرید شما حذف شد.'
            }
            this.countOrder--
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>
